import { getType } from 'typesafe-actions';
import { useApiQueryActions } from './actions';
const INITIAL_STATE = {
    id: null,
    paramsId: null,
    loading: false,
    data: null,
    error: null
};
export const useApiQueryReducer = (prev = INITIAL_STATE, action) => {
    switch (action.type) {
        case getType(useApiQueryActions.reset):
            return INITIAL_STATE;
        case getType(useApiQueryActions.request):
            return Object.assign(Object.assign({}, prev), { id: action.payload.id, paramsId: action.payload.paramsId, loading: true, data: action.payload.initData ||
                    (action.payload.dontReinitialize ? prev.data : null) });
        case getType(useApiQueryActions.success):
            if (isLiveRequest(prev, action)) {
                return Object.assign(Object.assign({}, prev), { loading: false, data: action.payload.data, error: null });
            }
            return prev;
        case getType(useApiQueryActions.failure):
            if (isLiveRequest(prev, action)) {
                return Object.assign(Object.assign({}, prev), { loading: false, data: null, error: action.payload.error });
            }
            return prev;
        case getType(useApiQueryActions.refetchRequest):
            // ensure that the refetch has the correct request params
            if (action.payload.paramsId === prev.paramsId) {
                return Object.assign(Object.assign({}, prev), { id: action.payload.id, paramsId: action.payload.paramsId, loading: true, data: action.payload.reinitialize ? null : prev.data });
            }
            return prev;
        case getType(useApiQueryActions.setData):
            return Object.assign(Object.assign({}, prev), { data: action.payload });
        default:
            return prev;
    }
};
/**
 * Ensures that the completed request was the last one that was called
 */
function isLiveRequest(prev, action) {
    return (action.payload.id === prev.id && action.payload.paramsId === prev.paramsId);
}
//# sourceMappingURL=reducer.js.map